import React, { Component } from "react";
import {
  View,
  TouchableHighlight,
  Dimensions,
  StyleSheet,
} from "react-native";
import Text from "../components_v2/TextFont";
import { translate } from "../locales/translate";

import PersianCalendarPicker from "react-native-persian-calendar-picker";
import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";
import {
  faCalendarWeek,
  faSyncAlt,
  faCheck,
  faEdit,
} from "../../assets/consts/faCharCodes";
import { IconButton } from "../components_v2/Buttons";
import * as faCharCodes from "../../assets/consts/faCharCodes";

import ArTheme from "../argon-ui/Theme";
import PropTypes, { number, string } from "prop-types";
import MonthPicker from "./MonthPicker";

let moment = require("moment-jalaali");

const SCREEN_HEIGHT = Dimensions.get("screen").height;
const SCREEN_WIDTH = Dimensions.get("screen").width;
const durations = {
  today: "today",
  thisWeek: "thisWeek",
  thisMonth: "thisMonth",
  thisYear: "thisYear",
  custom: "custom",
};

const durationTypes = {
  daily: "daily",
  monthly: "monthly",
};

/**@augments{Component<Props,state>} */
export default class PersianCalendar extends Component {
  static propTypes = {
    onDurationChange: PropTypes.func,
    onDateChange: PropTypes.func,
    onRefresh: PropTypes.func,
    onCustomDurationTypeChange: PropTypes.func,
    onMonthlyDurationChange: PropTypes.func,
    from: PropTypes.object,
    to: PropTypes.object,
    duration: PropTypes.oneOf([
      durations.today,
      durations.thisWeek,
      durations.thisMonth,
      durations.thisYear,
      durations.custom,
    ]),
    customDurationType: PropTypes.oneOf([
      durationTypes.daily,
      durationTypes.monthly,
    ]),
    monthlyStartYear: PropTypes.number,
    monthlyStartMonth: PropTypes.number,
    monthlyEndYear: PropTypes.number,
    monthlyEndMonth: PropTypes.number,
    minDate: PropTypes.string | number,
    initialDate: PropTypes.date | string,
  };
  constructor(props) {
    super(props);
    this.state = {
      duration: this.props.duration || durations.today,
      customDurationType: this.props.customDurationType || durationTypes.daily,
      dateFrom: this.props.from || null,
      dateTo: this.props.to || null,
      showDatePicker: false,
      showDatePickerText: this.props.duration == durations.custom || false,
      showMonthPicker: false,
      showCustomDurationDropdown:
        this.props.duration == durations.custom || false,
    };
  }

  handleDurationChange = (duration) => {
    this.setState(
      {
        duration,
        fromDate: null,
        toDate: null,
        showDatePicker: false,
        showDatePickerText: duration == durations.custom,
        showCustomDurationDropdown: duration == durations.custom,
      },
      () => {
        this.handleDateChange(null, "START_DATE");
        this.handleDateChange(null, "END_DATE");
        this.props.onDurationChange && this.props.onDurationChange(duration);
      }
    );
  };

  handleDateChange = (date, dateType) => {
    if (date) {
    }
    if (dateType == "START_DATE") {
      this.setState({ dateFrom: date }, () => {
        this.props.onDateChange && this.props.onDateChange(date, dateType);
      });
    } else if (dateType == "END_DATE") {
      this.setState({ dateTo: date }, () => {
        this.props.onDateChange && this.props.onDateChange(date, dateType);
      });
    }
  };

  handleCustomDurationTypeChange = (type) => {
    this.setState(
      {
        showDatePicker: type == durationTypes.daily,
        showDatePickerText: type == durationTypes.daily,
        showMonthPicker: type == durationTypes.monthly,
        customDurationType: type,
      },
      () => {
        this.props.onCustomDurationTypeChange &&
          this.props.onCustomDurationTypeChange(type);
      }
    );
  };

  handleMonthlyDurationChange = (data) => {
    typeof this.props.onMonthlyDurationChange === "function" &&
      this.props.onMonthlyDurationChange(data);
  };

  handleRefresh = () => {
    this.props.onRefresh && this.props.onRefresh();
  };

  renderTimeRangeSummary = () => {
    let { dateFrom, dateTo } = this.state;
    if (dateFrom == null && dateTo == null)
      return (
        <Text style={{ fontWeight: "bold" }}>
          {translate("deviceLog.last7Days")}
        </Text>
      );

    if (dateFrom == null && dateTo != null) {
      return (
        <Text>
          {translate("scenario.timeTo")}{" "}
          <Text style={{ fontWeight: "bold" }}>
            {moment(dateTo).format("jYYYY/jM/jD")}
          </Text>
        </Text>
      );
    }

    if (dateFrom != null && dateTo == null) {
      return (
        <Text>
          {translate("scenario.timeFrom")}{" "}
          <Text style={{ fontWeight: "bold" }}>
            {moment(dateFrom).format("jYYYY/jM/jD")}
          </Text>
        </Text>
      );
    }

    if (dateFrom != null && dateTo != null) {
      var jDateFrom = moment(dateFrom).format("jYYYY/jM/jD");
      var jDateTo = moment(dateTo).format("jYYYY/jM/jD");
      if (jDateFrom == jDateTo) {
        return (
          <Text>
            {translate("deviceLog.onDate", { from: "" })}{" "}
            <Text style={{ fontWeight: "bold" }}>{jDateFrom}</Text>
          </Text>
        );
      } else {
        return (
          <Text>
            {translate("scenario.timeFrom")}{" "}
            <Text style={{ fontWeight: "bold" }}>{jDateFrom}</Text>{" "}
            {translate("scenario.timeTo")}{" "}
            <Text style={{ fontWeight: "bold" }}>{jDateTo}</Text>
          </Text>
        );
      }
    }

    // {this.state.dateFrom != null &&
    //   this.state.dateTo != null &&
    //   moment(this.state.dateFrom).format("jYYYY/jM/jD") !=
    //     moment(this.state.dateTo).format("jYYYY/jM/jD") &&
    //   translate("deviceLog.fromToDates", {
    //     from: moment(this.state.dateFrom).format("jYYYY/jM/jD"),
    //     to: moment(this.state.dateTo).format("jYYYY/jM/jD"),
    //   })}

    // {this.state.dateFrom != null &&
    //   this.state.dateTo != null &&
    //   moment(this.state.dateFrom).format("jYYYY/jM/jD") ==
    //     moment(this.state.dateTo).format("jYYYY/jM/jD") &&
    //   translate("deviceLog.onDate", {
    //     from: moment(this.state.dateFrom).format("jYYYY/jM/jD"),
    //   })}
  };

  toggleDatePicker = () => {
    this.setState({ showDatePicker: true });
  };

  render() {
    let _durations = [];
    let _durationTypes = [];
    for (var i in durations) {
      _durations.push(durations[i]);
    }
    for (var i in durationTypes) {
      _durationTypes.push(durationTypes[i]);
    }
    let thisYear = Number(moment(new Date().toString()).format("jYYYY"));
    return (
      <View>
        <PersianCalendarPicker
          initialDate={this.props.initialDate}
          minDate={this.props.minDate}
          onDateChange={this.handleDateChange}
          // allowRangeSelection={true}
        />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  EditButton: {
    backgroundColor: ArTheme.COLORS.WARNING,
    borderRadius: 15,
    width: 30,
    height: 30,
    alignItems: "center",
    justifyContent: "center",
    //alignSelf: "flex-end",
  },
});
